"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable: no-unused-expression
const browser_1 = require("./browser");
const helpers_1 = require("./helpers");
const paramKeys_1 = require("./paramKeys");
/**
 * Note: Most of the code in this file was pulled from the ga.js
 * file. Some typing was added, some refactoring was done, but
 * generally it was left as-is.
 */
const isFromHost = (referrer, host) => {
    const pos = referrer.indexOf(host);
    if (5 === pos || 6 === pos) {
        const char = referrer.charAt(pos + host.length);
        if ('/' === char || '?' === char || '' === char || ':' === char) {
            return true;
        }
    }
    return false;
};
const getReferrer = (sendReferrer) => {
    const referrer = browser_1.default.getDocument().referrer;
    if (/^(https?|android-app):\/\//i.test(referrer)) {
        if (sendReferrer) {
            return referrer;
        }
        const host = '//' + browser_1.default.getDocument().location.hostname;
        if (!isFromHost(referrer, host)) {
            return referrer;
        }
    }
};
const init = (params) => {
    const navigator = browser_1.default.getWindow().navigator;
    const screen = browser_1.default.getWindow().screen;
    const location = browser_1.default.getDocument().location;
    params.set(paramKeys_1.default.Referrer, getReferrer(!!params.get(paramKeys_1.default.AlwaysSendReferrer)));
    if (location) {
        let path = location.pathname || '';
        if ('/' !== path.charAt(0)) {
            helpers_1.default.trace(31);
            path = '/' + path;
        }
        params.set(paramKeys_1.default.Location, location.protocol + '//' + location.hostname + path + location.search);
    }
    screen && params.set(paramKeys_1.default.ScreenResolution, screen.width + 'x' + screen.height);
    screen && params.set(paramKeys_1.default.ScreenColors, screen.colorDepth + '-bit');
    const el = browser_1.default.getDocument().documentElement;
    const body = browser_1.default.getDocument().body;
    const hasSize = body.clientWidth && body.clientHeight;
    let ca = [];
    if (el
        && el.clientWidth
        && el.clientHeight
        && ('CSS1Compat' === browser_1.default.getDocument().compatMode || !hasSize)) {
        ca = [el.clientWidth, el.clientHeight];
    }
    else {
        hasSize && (ca = [el.clientWidth, el.clientHeight]);
    }
    const vp = 0 >= ca[0] || 0 >= ca[1] ? '' : ca.join('x');
    params.set(paramKeys_1.default.ViewportSize, vp);
    params.set(paramKeys_1.default.Encoding, browser_1.default.getDocument().characterSet || browser_1.default.getDocument().charset);
    params.set(paramKeys_1.default.JavaEnabled, navigator && 'function' === typeof navigator.javaEnabled && navigator.javaEnabled() || false);
    params.set(paramKeys_1.default.Language, (navigator && (navigator.language || navigator.browserLanguage) || '').toLowerCase());
};
exports.default = {
    init,
};
